import React from 'react';

interface INavButtonProps {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  onClick?: () => void;
  pillText?: string;
  pillClassName?: string;
}

export const NavButton = (props: INavButtonProps) => {
  const { icon, label, active, onClick, pillText, pillClassName } = props;
  const showPill = !!pillText;
  const pillStyles = pillClassName ?? 'bg-yellow-200 text-yellow-800';

  return (
    <button
      onClick={onClick}
      className={`flex items-center w-full p-4 rounded-lg transition-colors cursor-pointer
        ${active ? 'bg-navHover' : 'hover:bg-navHover'}`}
    >
      <span className={'flex items-center gap-3'}>
        <span className={`${active ? 'text-primaryBlue' : ''}`}>{icon}</span>
        <span className={'flex items-center gap-2'}>
          <span className={`text-sm ${active ? 'font-semibold text-primaryBlue' : ''}`}>{label}</span>
          {showPill && (
            <span
              className={`text-xs font-medium px-2 py-1 rounded-full ${pillStyles}`}
            >
              {pillText}
            </span>
          )}
        </span>
      </span>
    </button>
  );
};
